module.exports = __webpack_public_path__ + "static/media/prokat_active.4522a518.png";